import { Collection, WhereField } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocsByClientId, getAllDocsByParkId, getDocByQueries, updateDoc } from './collectionBaseWorker';
import { where } from "firebase/firestore"

export const getAllContactInfoByClientId = async ({ clienteId }) => {
    return await getAllDocsByClientId({ collection: Collection.CONTACT_INFO, clienteId: clienteId })
}

export const getAllContactInfoByParkId = async ({ estacionamentoId }) => {
    return await getAllDocsByParkId({ collection: Collection.CONTACT_INFO, estacionamentoId: estacionamentoId })
}

export const getContactInfoByPlateAndClientId = async ({ plate, clienteId }) => {
    return await getDocByQueries({
        collection: Collection.CONTACT_INFO,
        queries: [
            where(WhereField.CLIENTEID, "==", clienteId),
            where(WhereField.PLATE, "==", plate.replaceAll("-").toUpperCase())
        ]
    })
}

export const getContactInfoByPlateAndParkId = async ({ plate, estacionamentoId }) => {
    return await getDocByQueries({
        collection: Collection.CONTACT_INFO,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.PLATE, "==", plate.replaceAll("-").toUpperCase())
        ]
    })
}

export const addOrUpdateContactInfo = async ({ data }) => {
    const exist = getContactInfoByPlateAndClientId({ plate: data.plate, clienteId: data.clienteId })
    if (!exist) {
        const doc = await addContactInfo({ data: data })
        return doc.id
    }
    return exist.id;
}

export const addContactInfo = async ({ data }) => {
    const doc = await addDoc({ collection: Collection.CONTACT_INFO, data: data })
    return doc.id;
}

export const updateContactInfoById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.CONTACT_INFO, id: id, data: data })
}

export const removeContactInfoById = async ({ id }) => {
    await deleteDoc({ collection: Collection.CONTACT_INFO, id: id })
}